<template>
  <section id="partners">
    <div class="row d-flex mt-1">
        <div class="col-12 our-partners mb-4" style="height: unset;">
            <span>Alianza en exclusiva solo para los mejores conductores</span>
        </div>
        <div class="col-6 col-sm-4 offset-sm-2 col-md-3 offset-md-3 text-center">
          <img src="@/assets/logos/logo-green@2x.png" width="90%">
        </div>
        <div class="col-1 col-sm-1 align-top float-left align-middle p-0">
          <div class="ml-2 pl-2 align-middle">
            <span class="plus-sign">+</span>
          </div>
        </div>
        <div class="col-5 col-sm-4 col-md-3">
          <img src="@/assets/logos/Uber_Logo_Black.png" width="100%">
        </div>
        <get-your-credit-button :sold-out="soldOut" :form-url="formUrl"></get-your-credit-button>
    </div>
  </section>
</template>

<script>
import GetYourCreditButton from './partials/GetYourCreditButton'
export default {
  name: 'AbacoPartnerUber',
  components: {GetYourCreditButton},
  props: {
    formUrl: '',
    soldOut: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
#partners {
  background-color: #fdfbf9;
  margin: 0;
  padding: 10px
}
.our-partners {
  height: 42px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 42px;
  text-align: center;
}
section.partners {
    padding: 100px 50px;
}

div.partner {
    text-align: center;
    margin-top: 20px;
}

.partner > img{
    width: 60px;
    height: 60px;
}
.plus-sign {
  line-height: 1;
  font-size: 3rem;
}
@media (min-width: 576px) {
  .plus-sign {
    font-size: 4.5rem;
    line-height: 1;
  }
}
@media (min-width: 992px) {
  .plus-sign {
    font-size: 6rem;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AbacoPartnerUber.vue